var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGanttIconNoBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 1518 c-45 -26 -44 -20 -44 -518 0 -501 -1 -493 46 -518 31 -17 1075 -17 1106 0 66 35 62 111 -7 138 -19 7 -194 10 -510 10 l-481 -1 -2 418 c-2 284 -6 425 -14 439 -10 20 -49 44 -67 44 -4 0 -16 -6 -27 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 1369 c-27 -15 -26 -124 1 -139 11 -6 87 -10 175 -10 180 0 186 3 186 80 0 78 -6 80 -188 80 -88 0 -165 -5 -174 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862 1138 c-16 -16 -16 -110 0 -126 17 -17 409 -17 426 0 7 7 12 35 12 63 0 28 -5 56 -12 63 -17 17 -409 17 -426 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236 914 c-21 -21 -21 -107 0 -128 12 -13 40 -16 139 -16 145 0 155 5 155 80 0 75 -10 80 -155 80 -99 0 -127 -3 -139 -16z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttIconNoBorder);
export default __webpack_public_path__ + "static/media/gantt-icon-no-border.39dc7a3d26185f6412f3901c5c98eea4.svg";
export { ForwardRef as ReactComponent };